import {DOCUMENT, Location} from '@angular/common';
import { inject, Injectable } from '@angular/core';
import {DOMAIN_PREFIX} from "../../core/constants/auth.constants";

@Injectable({
  providedIn: 'root',
})
export class ReturnUrlService {
  private location = inject(DOCUMENT).location;

  returnUrl: string;

  constructor() {
    const searchParams = new URLSearchParams(this.location.search);
    this.returnUrl = searchParams.get('returnUrl') || this.location.origin.replace(`${DOMAIN_PREFIX}.`, '');
  }
}
